<template>
    <a :href="href" @click.prevent="scrolling">
        <slot></slot>
    </a>
</template>

<script>
export default {
    props: ["href"],
    data() {
        return {};
    },
    watch: {},
    methods: {
        scrolling() {
            // For older browsers, consider pulling in a polyfill.
            // https://www.npmjs.com/package/smoothscroll-polyfill
            //document.querySelector(this.href).scrollIntoView({ behavior: "smooth" });

            const yOffset = -100;
            const element = document.querySelector(this.href);
            const y =
                element.getBoundingClientRect().top +
                window.pageYOffset +
                yOffset;

            window.scrollTo({ top: y, behavior: "smooth" });
        }
    },
    mounted() {},
    computed: {}
};
</script>

<style></style>
